module.exports = "/_next/static/media/6ea5e66c32639ea7ee62a52312b24936.svg";